import BrandAuditDetailPane from "./BrandAuditDetailPane";
import CategoryAnalysisDetailPane from "./CategoryAnalysisDetailPane";

/**
 * V2: detail pane for the merged Brand Assessment tab. Delegates per record —
 * Category Analysis runs (recordKind "categoryAnalysis") render the unchanged
 * CategoryAnalysisDetailPane, everything else the unchanged BrandAuditDetailPane.
 * For Category records the label/moduleKey are switched so the "View ..." button,
 * share name and report type labels read as Category Analysis.
 */
export default function BrandAuditV2DetailPane(props) {
  if (props.record?.recordKind === "categoryAnalysis") {
    return <CategoryAnalysisDetailPane {...props} moduleLabel="Category Analysis" moduleKey="categoryAnalysis" />;
  }
  return <BrandAuditDetailPane {...props} />;
}
